import { SelfServeContext } from "../types";

import { useSelfServeContextStore } from "./SelfServeContext";

interface IUseSelfServeContext {
  context: SelfServeContext;
}

export const useSelfServeContext = (): IUseSelfServeContext => {
  const [context] = useSelfServeContextStore([
    "tree",
    "level1Node",
    "level2Node",
    "level3Node",
    "level4Node",
    "level5Node",
    "brandOrders",
    "selectedBrandOrder",
  ]);

  return { context };
};
